import { render } from "./MarginLayout.vue?vue&type=template&id=7d29c1c4"
import script from "./MarginLayout.vue?vue&type=script&lang=js"
export * from "./MarginLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__